import { controls, grouped } from "../controls";
const calamity_fund_transactions = {
  label: "Calamity Fund Transactions",
  pageLabel: "Calamity Fund Transactions", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: false } },
  pageType: "history",
  formTabs:
  {
    allTabs: [
      { label: "General", uid: "general" },
      { label: "Bank's Suggestion", uid: "bank_suggestion_talathi", fastpath: "bank_suggestion_talathis" }
    ]
  },
  filter: [
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Account No", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "account_no", maxlength: 20, isRequired: true }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", label: "Ifsc", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "ifsc", maxlength: 11 }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", label: "Check at bank" }),
    ...controls.oc({ tab: "general", c: "Account", placeHolder: "Check at bank", name: "bank_account_code", displayData: { account_display: "bank_account_display" }, hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "bank_account_display" }),
    ...controls.displayText({ tab: "general", label: "Full Name", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "full_name", width: "col-sm-4", maxlength: 500, isReadOnly: "edit" }),
    ...controls.displayText({ tab: "general", label: "Total Amount" }),
    ...controls.floatOnly({ tab: "general", placeHolder: "", name: "total_amount", maxlength: 18, isReadOnly: "edit", isReadOnly: true }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", label: "Name at Bank", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "cbs_name", width: "col-sm-4", maxlength: 200, isReadOnly: "edit", isReadOnly: true }),
    ...controls.displayText({ tab: "general", label: "Mobile", star: false }),
    ...controls.mobileNumber({ tab: "general", placeHolder: "", name: "mobile" }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "general", label: "Confirm Match", default: false, name: "confirm_match" }),
    ...controls.displayText({ tab: "bank_suggestion_talathi", label: "Bank Suggestion", star: false }),
    ...controls.text({ tab: "bank_suggestion_talathi", placeHolder: "", name: "bank_suggestion_talathi.bank_suggestion", width: "col-sm-4", maxlength: 200 }),


    ...controls.displayText({ tab: "general", label: "", width: "col-sm-12" }),

    ...controls.displayText({ tab: "general", label: "", width: "col-sm-5" }),

    ...controls.button({ tab: "general", style: { marginTop: 30 }, Bcolor: "danger", width: "col-sm-2", label: "Close Form", onclick: { action: "closeTab" } })

  ]
  , history: {
    perPage: 10,
    reportHeader: "Calamity Fund Transactions",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Account No", accessor: "account_no", },
      { Header: "Ifsc", accessor: "ifsc", },
      { Header: "Check at bank", accessor: "bank_account_code", },
      { Header: "Full Name", accessor: "full_name", },
    ]
  }
};
export default calamity_fund_transactions;